import React from "react";
import matchMakerPhone from "./images/4_matchmaker/matchmaker_phone.png";
import { TITLE_FONT_SIZE, TEXT_FONT_SIZE } from "./const.js";

const Matchmaker = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyItems: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          color: "black",
          paddingLeft: 10,
          alignItems: "flex-end",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            fontFamily: "OswaldBoldItalic",
            flex: 1,
            textAlign: "right",
            marginBottom: 10,
            fontSize: TITLE_FONT_SIZE,
            marginRight: "20%",
          }}
        >
          A NEW MATCHMAKER IS HERE
        </div>
        <div
          style={{
            display: "flex",
            flex: 1,
            textAlign: "right",
            marginBottom: 30,
            maxWidth: "70%",
            fontSize: TEXT_FONT_SIZE,
            marginRight: "20%",
          }}
        >
          Storm Fans around the world love exploring the MatchMaker! This tool
          makes ball recommendations based on your style and the conditions you
          see the most.
        </div>
      </div>
      <div style={{ display: "flex", flex: 1 }}>
        <div
          style={{
            display: "flex",
            flex: 1,
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <img
            style={{ width: "80%" }}
            src={matchMakerPhone}
            alt={"Matchmaker photo"}
          />
        </div>
      </div>
    </div>
  );
};

export default Matchmaker;
